import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import SingleNextButton from '../Atoms/SingleNextButton';
import StepShell from '../StepComponents/StepShell';
import Form from '../StepComponents/Form';
import ApplicationReview from './StepReviewComponents/ApplicationReview';
import TermsAndConditions from './StepReviewComponents/TermsAndConditions';
import CheckBoxAgreement from './StepReviewComponents/CheckBoxAgreement';
import { setApp, getApp} from '../../index';

class StepFinalAgreements extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            token: ""
        };

        this.onRecaptchaClick = this.onRecaptchaClick.bind(this);
    }

    onRecaptchaClick(value) {
        if(value){
            setTimeout(function () {
                this.setState({
                    token:value
                });
                setApp("recaptchaVerify", true);
            }.bind(this), 1000);
        }
    }
    
    render() {

        var recaptcha = <ReCAPTCHA sitekey="6LcSp6wUAAAAAMvq6WEj4S3DVvwcijxMRBg56h1p" onChange={this.onRecaptchaClick} />;
        var nextButton = null;

        if(getApp("recaptchaVerify") === true){
            recaptcha = null;
        }

        if(this.state.token.length > 0 || getApp("recaptchaVerify") === true){
            recaptcha = null;
            nextButton = (<SingleNextButton nextBtnTxt="Complete Application" />)
        }

        return (
            <StepShell stepID="StepFinalAgreements"
                friendlyText="Just confirm everything looks correct and we’re done."
                requestText="Be sure to review carefully. Your application isn’t submitted until you click “Complete Application” at the bottom of the page."
                progress="90%"
                progressLabel="Final Review"
                backLink="/loan-application/disclosures"
            >
                <ApplicationReview /><br />
                <TermsAndConditions /><br />
                <Form nextLink="/loan-application/overview">
                    <div className="membership-qualification-viewed p-sm">
                        <div className="membership-qualification-checkbox hug">
                            <CheckBoxAgreement name="membershipQualification" label="I have read and agree to the Terms & Conditions listed above" />
                        </div>
                    </div>
                    <div className="loanApp-form-row">
                        <div className="col col-12">
                            {recaptcha}
                        </div>
                    </div>
                    {nextButton}
                    {/* <SingleNextButton nextBtnTxt="Complete Application" /> */}
                </Form>
            </StepShell>
        )
    }
}

export default StepFinalAgreements;